import "./Styling/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Showcase from "./Views/Home/Showcase";
import Header from "./Views/Home/Header";
import Workflow from "./Views/Home/Workflow";
import Quality from "./Views/Home/Quality";
import NavBar from "./Views/Home/NavBar";
import PortfolioList from "./Views/Portfolio/PortfolioList";
import PortfolioDetails from "./Views/Portfolio/PortfolioDetails";
import Contact from "./Views/Contact/Contact";
import useDocumentTitle from "./Utilities/useDocumentTitle"
import PortfolioPrivacy from "./Views/Portfolio/PortfolioPrivacy";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<PortfolioList />} />
        <Route path="/portfolio/details/:id" element={<PortfolioDetails />} />
        <Route path="/portfolio/details/:id/privacy" element={<PortfolioPrivacy />} />
      </Routes>
    </BrowserRouter>
  );
}

const Home = () => {

  useDocumentTitle("42nd");

  return (
    <main className="main-wrapper">
      <div className="main-content">
        <NavBar />
        <Header />
        <Showcase />
        <Quality />
        <Workflow />
      </div>
    </main>
  )
}

export default App;
